import { FC } from 'react';

import Flower from '@/assets/flower.svg?react';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';

interface Props {
  amount: number;
  className?: string;
}

const ReceiveBadge: FC<Props> = ({ className, amount }) => {
  const { i18n } = useLingui();

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-md bg-gray-200 p-3.5 text-blue-600 md:p-6',
        className
      )}
    >
      <Flower className="min-h-5 min-w-5" />
      <p className="h3">
        {i18n.t('Otrzymasz')}{' '}
        {amount.toLocaleString('PL', {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </p>
    </div>
  );
};

export default ReceiveBadge;
